module.exports = "../../../../platform/assets/pageMainIcon/cd-number-quantity.svg";